/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import Description from "App/model/description";
import {RenderElement} from "App/model/elements/element";

export default
class GlobeModel extends RenderElement {

    public static TypeName: string = "GlobeModel";

    private _patches: any[] = [];
    private _models: any[] = [];

    constructor (aModelDescription: Description){
        super(aModelDescription);
    }

    public static create(aModelDescription, aUID: number): GlobeModel
    {
        let obj = new GlobeModel(aModelDescription);
        obj._typeName = GlobeModel.TypeName;
        obj._UID = aUID;
        return obj;
    }

    public parse(aElementDescriptionJSON: any): boolean {
        let ret = super.parse(aElementDescriptionJSON);
        if (!ret) {
            return false;
        }

        if (aElementDescriptionJSON.patches) {
            this._patches = aElementDescriptionJSON.patches;
        }

        if (aElementDescriptionJSON.models) {
            this._models = aElementDescriptionJSON.models;
        }

        // let's crete a new globe model
        let globe = this._modelDescription.getSceneAPI().createGlobe(this._modelDescription.getRenderModel().getDocument());
        globe.setGlobeModelElement(this);

        // publish the globe to the scene api, this is a hack and we should intead made some globe manager which will manage it
        this._modelDescription.getSceneAPI().globe = globe;

        return true;
    }

    public getPatches(): any[] {
        return this._patches.slice();
    }

    public getModels(): any[]
    {
        return this._models.slice();
    }
}